
































































































































































import { Component, Ref } from 'vue-property-decorator'
import RouterHelper from '@/mixins/RouterHelper.vue'
import ModuleIntroduction from '@/components/common/ModuleIntroduction.vue'
import ModuleWrapper from '@/components/common/ModuleWrapper.vue'
import StickyButton from '@/components/common/StickyButton.vue'
import ResultWrapper from '@/components/common/ResultWrapper.vue'
import { ElForm } from 'element-ui/types/form'
import { getPlotParams, resultPlot } from '@/request/apis/CellCommunicationRequest'
import Gallery from '@/components/common/Gallery.vue'
import { getSocket } from '@/socket.io'
import DropdownGroup from '@/components/common/DropdownGroup.vue'
import { addTimeStamp } from '@/utils/util'

@Component({
  components: {
    Gallery,
    DropdownGroup,
    StickyButton,
    ResultWrapper,
    ModuleWrapper,
    ModuleIntroduction
  }
})

export default class CellCommunicationResult extends RouterHelper {
  @Ref('form') readonly submitForm!: ElForm
  @Ref('dropdown') readonly dropdown!: DropdownGroup

  private groupList: any[] = []
  private plotFigure: any = {
    threshold_dot: 0.05,
    threshold_heatmap: 0.05,
    source: [],
    target: []
  }
  private dotUrl: string = ''
  private heatmapUrls: any[] = []
  private thumbList: any[] = []
  private thumbName: any[] = []
  private imgDownloadUrl: string = ''
  private currentIndex: number = 0
  private loadingProcessButton: boolean = false

  get id () {
    return this.$route.params.id
  }

  /**
   * 表单提交
   */
  private submitHandler () {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loadingProcessButton = true
        try {
          let params: any = {
            job_id: this.id,
            threshold_dot: this.plotFigure.threshold_dot,
            threshold_heatmap: this.plotFigure.threshold_heatmap,
            source: this.plotFigure.source,
            target: this.plotFigure.target
          }
          await resultPlot(null, params).start()
        } catch (e) {
          this.loadingProcessButton = false
        }
      } else {
        return false
      }
    })
  }

  /**
   * 监听 websocket 消息
   */
  private async addSocketListener () {
    await this.$nextTick()
    const socket = getSocket()
    if (!socket) return
    socket.on('plot_finish', (res: any) => {
      const result = res.data
      if (result.job_id !== this.id) return // 如果更新的不是此任务就return
      this.loadingProcessButton = false
      this.dropdown.getDownloadData(this.id)
      if (result.status === 'error') {
        this.$notify.error({
          title: '提示',
          message: '图像生成失败',
          offset: 90,
          duration: 10000
        });
        return
      }
      // url相同时 img不更新, 拼接参数重新读取
      this.dotUrl = result.dot_url + '?' + (new Date()).getTime()
      this.heatmapUrls = addTimeStamp(result.heatmap_url)
      this.thumbList = addTimeStamp(result.images)
      this.imgDownloadUrl = result.images_download
      this.thumbName = this.thumbList.map((item: string) => {
        return decodeURIComponent(item.split('/')[item.split('/').length - 1].split('.')[0])
      })
    })
  }

  /**
   * 获取结果数据并显示
   */
  private async getResult () {
    const plotParams = await getPlotParams(null, this.id).start()
    this.groupList = plotParams.group_list
  }

  private get rules () {
    return {
      source: [
        { required: true, message: new Error(<string>this.$t('form.params.checkParams')), trigger: 'change' }
      ],
      target: [
        { required: true, message: new Error(<string>this.$t('form.params.checkParams')), trigger: 'change' }
      ]
    }
  }

  mounted () {
    this.getResult()
    this.addSocketListener()
  }

  destroyed () {
    const socket = getSocket()
    socket.off('plot_finish')
  }
}
